import React from 'react';
import { COVER_LOGO } from '../coverLogo';
import { useRegion } from '../region';

export const blankCover = (region) => ({
  datePresented: new Date().toISOString().slice(0, 10),
  revision: '0', preparedBy: '', preparedByEmail: '',
  ...(region === 'US' ? { address: '', telephone: '' }
    : { address: '16A Palmer Parade, Cremorne VIC 3121', telephone: '(03) 8416 1500' }),
});

// 9/07/2026 style (AU day/month/year, no leading zero on the day) as in the template.
function fmtDate(iso, region) {
  if (!iso) return '';
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  if (!m) return iso;
  return region === 'US'
    ? `${parseInt(m[2], 10)}/${parseInt(m[3], 10)}/${m[1]}`
    : `${parseInt(m[3], 10)}/${m[2]}/${m[1]}`;
}

// 1:1 recreation of "LPA Proposal Template_LT1.docx" (measured from the rendered page).
export default function CoverPage({ name, cover }) {
  const c = cover || {};
  const letter = useRegion() === 'US';
  return (
    <div className={'ds-page ds-cover2' + (letter ? ' letter' : '')} data-export-page data-testid="proposal-cover-page">
      <div className="c2-fit">
      <img className="c2-logo" src={COVER_LOGO} alt="LPA" data-testid="proposal-cover-logo" />
      <div className="c2-title" data-testid="proposal-cover-title">Datasheet for {name || ''}</div>
      <div className="c2-rule" />
      <div className="c2-meta">
        <div className="c2-row">Date Presented: <span className="c2-date">{fmtDate(c.datePresented, letter ? 'US' : 'AU')}</span></div>
        <div className="c2-row">Revision : {c.revision || '0'}</div>
        {(c.preparedBy || '').trim() ? <div className="c2-row c2-prep">Prepared by <b>{c.preparedBy}</b></div> : null}
        {(c.preparedByEmail || '').trim() ? <div className="c2-row c2-link">{c.preparedByEmail}</div> : null}
        <div className="c2-gap" />
        {(c.address || '').trim() ? <div className="c2-row">Address: {c.address}</div> : null}
        {(c.telephone || '').trim() ? <div className="c2-row">Telephone: <span className="c2-link">{c.telephone}</span></div> : null}
      </div>
      </div>
    </div>
  );
}
